import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import TimeSheetSummaryReportHeader from "../../../components/TimeSheetReports/TimeSheetSummaryReport/TimeSheetSummaryReportHeader";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { RootState } from "../../../redux/rootReducers";
import {  resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import { getAllMasterDataBranchAction } from "../../../redux/masterData";
import { GetAllMasterDataBranchPayloadType } from "../../../commonTypes/masterDataTypes";
import useDebounce from "../../../customHooks/useDebounce";
import {
  getTimeSheetSummaryReportAction,
  resetBillableSumTotal,
  resetEmployeeWithoutFillTimesheetCount,
  resetEmployeeWithoutFillTimesheetList,
  resetNonBillableSumTotal,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetTimeSheetSummaryReportListing,
  resetTimeSheetSummaryReportTotalCount,
  resetTotalHoursSumTotal,
} from "../../../redux/timeSheet";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import TimeSheetSummaryReportTable from "../../../components/TimeSheetReports/TimeSheetSummaryReport/TimeSheetSummaryReportTable";
import { TIMESHEET_SUMMARY_REPORT_HEADERS } from "../../../constant/timeSheetReportDropDown/timeSheetListConst";
import OpenEmployeeWithNoTimesheetEntry from "../../../components/TimeSheetReports/TimeSheetSummaryReport/OpenEmployeeWithNoTimesheetEntry";
import { GetTimeSheetSummaryReportDataPayloadType } from "../../../commonTypes/timeSheetTypes";
import { EmployeeWithoutFillTimesheetListType, TimesheetSummaryReportListType,  } from "../../../redux/timeSheet/timeSheetType";
export type DropDownUserType = {
  value: number | null;
  label: string;
};
type AppProps = {
  token: string | null;
  branchFetching: boolean;
  branchDataList: any;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  fetching: boolean;
  masterDataBranchListTotal: string | number;
  billableSumTotal: number;
  nonBillableSumTotal: number;
  totalHoursSumTotal: number;
  employeeWithoutFillTimesheetList:EmployeeWithoutFillTimesheetListType[]|[]
  withoutFillTimesheetCount:number
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => void;
  dispatchGetTimeSheetSummaryReportAction: (data: GetTimeSheetSummaryReportDataPayloadType) => void;
  dispatchResetTimeSheetSummaryReportTotalCount: () => void;
  dispatchResetTimeSheetSummaryReportList: () => void;
  dispatchResetSession: () => void;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetBillableSumTotal: () => void;
  dispatchResetNonBillableSumTotal: () => void;
  dispatchResetTotalHoursSumTotal: () => void;
  dispatchResetEmployeeWithoutFillTimesheetList:()=>void;
  dispatchResetEmployeeWithoutFillTimesheetCount:()=>void;
  timesheetSummaryReportList: TimesheetSummaryReportListType[]|[];
  totalCount: string | number;
};
const TimSheetSummaryReport = ({
  token,
  branchFetching,
  branchDataList,
  masterDataBranchListTotal,
  billableSumTotal,
  nonBillableSumTotal,
  totalHoursSumTotal,
  employeeWithoutFillTimesheetList,
  withoutFillTimesheetCount,
  dispatchGetAllMasterDataBranchListAction,
  dispatchGetTimeSheetSummaryReportAction,
  dispatchResetTimeSheetSummaryReportTotalCount,
  dispatchResetTimeSheetSummaryReportList,
  dispatchResetSession,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetBillableSumTotal,
  dispatchResetNonBillableSumTotal,
  dispatchResetTotalHoursSumTotal,
  dispatchResetEmployeeWithoutFillTimesheetList,
  dispatchResetEmployeeWithoutFillTimesheetCount,
  timesheetSummaryReportList,
  totalCount,
  statusCode,
  success,
  error,
  message,
  fetching,
}: AppProps) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [offset, setoffset] = useState<number>(0);
  const [listOffset, setListOffset] = useState<number>(0);
  const [listLimit, setListLimit] = useState<number>(20);
  const [limit, setLimit] = useState<number>(20);
  const [text, setText] = useState<string>("");
  const [branchText, setBranchText] = useState<string>("");
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [branch, setBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select..",
  });
  const [downloadFinalData, setDownloadFinalData] = useState({});
  const [showViewButton , setShowViewButton] = useState(false)
  const [data, setData] = useState<TimesheetSummaryReportListType[]|[]>([]);
  const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");
  const [showUserWithNotimesheetModal, setShowUserWithNotimesheetModal] = useState(false);


  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetTimeSheetSummaryReportTotalCount();
    dispatchResetTimeSheetSummaryReportList();
    dispatchResetBillableSumTotal();
    dispatchResetNonBillableSumTotal();
    dispatchResetTotalHoursSumTotal();
  }, []);

  useEffect(() => {
    if (timesheetSummaryReportList?.length === 0) {
      setData(timesheetSummaryReportList);
    }
    if (listOffset > 0) {
      setData((prv: any) => [...prv, ...timesheetSummaryReportList]);
    } else {
      setData(timesheetSummaryReportList);
    }
  }, [timesheetSummaryReportList]);

  useEffect(() => {
    dispatchResetTimeSheetSummaryReportTotalCount();
    if (token) {
      if (startDate && endDate) {
        let finalData: GetTimeSheetSummaryReportDataPayloadType = {
          token,
          offset:listOffset,
          limit:listLimit,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
          branch_filter: branch?.value,
        };
        if (listOffset < +totalCount) {
          dispatchGetTimeSheetSummaryReportAction(finalData);
        } else if (listOffset === 0 && totalCount === "") {
          dispatchGetTimeSheetSummaryReportAction(finalData);
        }
      }
    }
  }, [listOffset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        search_term: text,
        branch_status:1
      };
      if (offset <= +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalUserData);
      }
    }
  }, [offset]);

  useEffect(() => {
    const branchData = branchDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.branch_name,
      };
    });
    if (offset > 0) {
      setFinalBranchDataList([...finalBranchDataList, ...branchData]);
    } else {
      setFinalBranchDataList(branchData);
    }
  }, [branchDataList]);
  
  
  const fetchNewBranchData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: branchText,
      branch_status:1
    };
    dispatchGetAllMasterDataBranchListAction(finalData);
  };

  useDebounce(
    () => {
      if (branchText) {
        fetchNewBranchData(branchText);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          search_term: branchText,
          branch_status:1
        };
        dispatchGetAllMasterDataBranchListAction(finalData);
      }
    },
    500,
    [branchText]
  );

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        listOffset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (timesheetSummaryReportList?.length > 0) {
          if (!fetching && listOffset < +totalCount) {
            setListOffset(listOffset + listLimit);
          }
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [timesheetSummaryReportList]);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleBranchDropDownChange = (data: any) => {
    setBranch({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmitData = () => {
    setShowViewButton(true)
    setCurrentStartDate(formatDate(startDate));
    setCurrentEndDate(formatDate(endDate));
    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: GetTimeSheetSummaryReportDataPayloadType = {
        token,
        branch_filter: branch?.value,
        limit: listLimit,
        offset: listOffset,
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      };
      setDownloadFinalData(finalData);
      if (listOffset === 0) {
        dispatchGetTimeSheetSummaryReportAction(finalData);
      } else {
        setListOffset(0);
      }
    }
  };
  const handleUserWithNoTimesheet = () => {
    setShowUserWithNotimesheetModal(!showUserWithNotimesheetModal);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
              dispatchResetTimeSheetSummaryReportList();


            }}
          />
        );
      }
    }
    if (success === 1 && message === "Billable and non-billable sums fetched successfully!") {
      dispatchResetTimeSheetReportMessage();
      dispatchResetTimeSheetReportSuccess();
      dispatchResetTimeSheetSummaryReportList();
    }
    return false;
  };
  return (
    <div>
      <CommonHeader title="Timesheet Summary Report" />
      <div className="new-table-card">
        <div className="row">
          <div className="col-md-12 pl-2 pr-2 mt-4 mb-4">
            <TimeSheetSummaryReportHeader
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              handleSubmitData={handleSubmitData}
              setText={setText}
              setBranchText={setBranchText}
              branchFetching={branchFetching}
              finalBranchDataList={finalBranchDataList}
              setoffset={setoffset}
              limit={limit}
              handleBranchDropDownChange={handleBranchDropDownChange}
              branch={branch}
              showViewButton={showViewButton}
              handleUserWithNoTimesheet={handleUserWithNoTimesheet}
              timesheetSummaryReportList={timesheetSummaryReportList}
              token={token}
              downloadFinalData={downloadFinalData}
              currentStartDate={currentStartDate}
              currentEndDate={currentEndDate}

            />
          </div>
        </div>
        {!!timesheetSummaryReportList?.length && (
          <div
            className=""
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "-16px",
              marginBottom:'20px'
            }}
          >
            <div
              style={{ marginTop: "5px", marginLeft: "15px" }}
              className="mt-0"
            >
              <span
                className="ml-4"
                style={{
                  fontWeight: "500",
                  letterSpacing: "0.34px",
                  fontSize: "16px",
                }}
              >
                All User Timesheet Report
              </span>{" "}
              <span
                className="ml-4"
                style={{
                  padding: "26px 1px 0",
                  color: "#7c8db0",
                  fontSize: "14px",
                }}
              >
                {currentStartDate} To {currentEndDate}
              </span>
            </div>
          </div>
        )}
          <>
            {fetching && listOffset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : timesheetSummaryReportList?.length > 0 ? (
              <div className="jobsType">
                <table className="table thead-light table-bordered">
                  <thead className="text-start sticky-table-header-without-zindex">
                    <tr className="new-table-head" style={{ fontSize: "11px" }}>
                      <td style={{backgroundColor:'#e8ecf0'}}>
                        <strong>Total</strong>
                      </td>
                      <td style={{backgroundColor:'#e8ecf0'}}>
                        <strong>
                          {billableSumTotal ? billableSumTotal.toFixed(2) : 0}
                        </strong>
                      </td>
                      <td style={{backgroundColor:'#e8ecf0'}}>
                        <strong>
                          {nonBillableSumTotal
                            ? nonBillableSumTotal.toFixed(2)
                            : 0}
                        </strong>
                      </td>
                      <td style={{backgroundColor:'#e8ecf0'}}>
                        <strong>
                          {totalHoursSumTotal
                            ? totalHoursSumTotal.toFixed(2)
                            : 0}
                        </strong>
                      </td>
                    </tr>
                    <TableHeader
                      tableHeader={TIMESHEET_SUMMARY_REPORT_HEADERS}
                    />
                  </thead>
                  <tbody>
                    <TimeSheetSummaryReportTable
                      data={data}
                      tableHeaders={TIMESHEET_SUMMARY_REPORT_HEADERS}
                    />
                    <div style={{ display: fetching ? "none" : "inline" }}>
                      <ScrollToTop />
                    </div>
                    {fetching && listOffset > 0 && <div>{<InfiniteLoader />}</div>}
                  </tbody>
                </table>
              </div>
            ) : (
              <>
            
                {!fetching && data?.length === 0 && (
                  <div className="pb-4 pl-0 pr-0">
                  <EmptyListPage
                    title="No Timesheet List!"
                    text={!currentStartDate && !currentEndDate ? "Choose start date and end date to get timesheet summary report" : ""}
                    imageWidth="30%"
                    image={EmptyTimeSheetReportList}
                    showAddButton={false}
                  />
                  </div>
                )}
              </>
            )}
          </>
      </div>
      {showUserWithNotimesheetModal && (
        <OpenEmployeeWithNoTimesheetEntry
          isOpen={showUserWithNotimesheetModal}
          toggle={() => {
            handleUserWithNoTimesheet();
          }}
          fetching={fetching}
          listOffset={listOffset}
          employeeWithoutFillTimesheetList={employeeWithoutFillTimesheetList}
        />
      )}
      {handleErrorModal()}

    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  timesheetSummaryReportList: state.timeSheet.timesheetSummaryReportList,
  totalCount: state.timeSheet.timsheetSummaryReportTotal,
  billableSumTotal: state.timeSheet.billableSumTotal,
  nonBillableSumTotal: state.timeSheet.nonBillableSumTotal,
  totalHoursSumTotal: state.timeSheet.totalHoursSumTotal,
  employeeWithoutFillTimesheetList:state.timeSheet.employeeWithoutFillTimesheetList,
  withoutFillTimesheetCount: state.timeSheet.employeeWithoutFillTimesheetCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>dispatch(resetTimeSheetStatusCode()),
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => {dispatch(getAllMasterDataBranchAction(data))},
  dispatchGetTimeSheetSummaryReportAction: (data: GetTimeSheetSummaryReportDataPayloadType) => dispatch(getTimeSheetSummaryReportAction(data)),
  dispatchResetTimeSheetSummaryReportTotalCount: () => dispatch(resetTimeSheetSummaryReportTotalCount()),
  dispatchResetTimeSheetSummaryReportList: () => dispatch(resetTimeSheetSummaryReportListing()),
  dispatchResetBillableSumTotal: () => dispatch(resetBillableSumTotal()),
  dispatchResetNonBillableSumTotal: () => dispatch(resetNonBillableSumTotal()),
  dispatchResetTotalHoursSumTotal: () => dispatch(resetTotalHoursSumTotal()),
  dispatchResetEmployeeWithoutFillTimesheetList: () => dispatch(resetEmployeeWithoutFillTimesheetList()),
  dispatchResetEmployeeWithoutFillTimesheetCount: () => dispatch(resetEmployeeWithoutFillTimesheetCount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimSheetSummaryReport);
